/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable view-models/no-unused-meta */
/* eslint-disable react/prop-types */
// TODO: remove view-models/no-unused-meta and eslint-disable react/prop-types rule when this issue https://github.com/asbjornh/view-models/issues/18 is resolved
import React from 'react';
import ButtonBase from 'components/models/button-base';
import { isDarkColor } from 'js/color-detection-utils';
import PropTypes from 'prop-types';
import cn from 'classnames';

const CtaButton = ({
  className,
  backgroundColor,
  url,
  text,
  openInNewTab = false,
}) => {
  const style = backgroundColor
    ? {
        '--cta-bg-color': backgroundColor,
        '--cta-text-color': isDarkColor(backgroundColor)
          ? '#ffffff'
          : '#00004F',
      }
    : undefined;

  return (
    <a
      href={url}
      className={cn('cta-button', className)}
      target={openInNewTab ? '_blank' : null}
      rel={openInNewTab ? 'nofollow noopener' : null}
      style={style}
    >
      <span className="cta-button__text">{text}</span>
    </a>
  );
};

CtaButton.viewModelMeta = {
  className: 'ignore',
  tabindex: 'ignore',
};

CtaButton.propTypes = Object.assign({}, ButtonBase.propTypes, {
  tabindex: PropTypes.number,
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
});

export default CtaButton;
